<template>
    <el-form ref="form" label-width="150px" :model="form" size="small" :rules="rules">
        <div style="width:1000px; padding:20px 450px; margin-bottom:10px;">
            <b style="font-size:18px">Sale Leads</b>
        </div>
        <div style="width:1000px;">
            <el-form-item label="Company Name" prop="CompanyName">
                <el-input v-model="form.CompanyName" :disabled="true"></el-input>
            </el-form-item>

            <el-form-item label="Country" prop="Country">
                <el-input v-model="form.Country" :disabled="true"></el-input>
            </el-form-item>

            <el-form-item label="Contact Info" prop="ContactInfo">
                <el-input v-model="form.ContactInfo" :disabled="true"></el-input>
            </el-form-item>

            <el-form-item label="Note from Sales">
                <el-input v-model="form.NotefromSales" :disabled="true"></el-input>
            </el-form-item>

            <el-form-item label="Expect Time" prop="ExpectTime">
                <el-date-picker
                    v-model="form.ExpectTime"
                    type="date" :disabled="true">
                </el-date-picker>
            </el-form-item>
            
            <el-form-item label="Partner" prop="Partner">
            <el-select v-model="form.Partner" placeholder="" :disabled="true">
                <el-option
                    v-for="item in partnerList"
                    :key="item.ID"
                    :label="item.CompanyName"
                    :value="item.ID">
                </el-option>
            </el-select>
            </el-form-item>

            <el-form-item  label="Status">
            <el-select v-model="form.Status" placeholder="" :disabled="true">
                <el-option
                    v-for="item in statusList"
                    :key="item.ID"
                    :label="item.Name"
                    :value="item.ID">
                </el-option>
            </el-select>
            </el-form-item>

            <el-form-item label="Process Result">
                <el-input v-model="form.Result" :disabled="true"></el-input>
            </el-form-item>
        </div>

    <div style="padding:20px 0;border-bottom:1px solid #e2e2e2;margin-bottom:20px; width:1000px;">
            <p class="title">Description</p>
            </div>
            <div  class="html-text-content" v-html="data.Description"></div> 
          
     <br><br><br>
        <div style="padding-left:915px; padding-top:50px; float:left;">
       <el-button class="submit" type="primary" @click="submit">Close</el-button>
        </div>
    </el-form>
</template>

<script>
import {orderStatusList } from "@/components/SaleLeads/data.js";
export default {
    props:{
        id:{}
    },
    data () {
        return {
            data:{},
            form:{
                CompanyName:"",
                Country:"",
                ContactInfo:"",
                NotefromSales:"",
                ExpectTime:"",
                Partner:"",
                Status:"",
                Result:""
            },
            statusList:orderStatusList,
            rules:{
                CompanyName:[{ required: true, message: 'Please enter your company name', trigger: 'blur' }],
                Country:[{ required: true, message: 'Please enter your country', trigger: 'blur' }],
                ContactInfo:[{ required: true, message: 'Please enter your contact info', trigger: 'blur' }],
                ExpectTime:[{type: 'date', required: true, message: 'Please select the time', trigger: 'change'}],
                Partner:[{ required: true, message: 'Please select a partner', trigger: 'blur' }]
            },
            partnerList:[]
        };
    },
    mounted () {
        this.$http.get("getAllPartner",{},(data)=>{
            this.partnerList = data.data;
        });
    },
    created () {
        if(this.id)
            this.$http.get("getSaleLeadsInfo",{
                ID:this.id
            },(data)=>{
                this.data = data.data;
                this.form.ExpectTime = new Date(this.data.ExpectTime);
                this.form.CompanyName = this.data.CompanyName;
                this.form.Country = this.data.Country;
                this.form.ContactInfo = this.data.ContactInfo;
                this.form.NotefromSales = this.data.NotefromSales;
                this.form.Partner = this.data.Partner;
                this.form.Status = this.data.Status;
                this.form.Result = this.data.Result;
            });
    },
    methods:{
        submit () {this.$router.push("/saleLeads");}
    }
};
</script>
<style lang="less" scoped>
    .html-text-content{
        table td,table th {
            border-bottom: 1px solid #ccc;
            border-right: 1px solid #ccc;
            
        }
        padding-left: 20px;
    }
</style>
